module.exports = __webpack_public_path__ + "img/advantage4@2x.e3ca60ae.png";